import { Box, Dialog, DialogContent, Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import {
  addFileStatus,
  addTrailer,
  fileUploadTrailer,
  updateTrailer
} from '../../../redux/reducer/truckManagementSlices/trailerSlice';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import CustomSelect from '../../../../../common/components/customized/customselect/CustomSelect';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import CustomDateCalendar from '../../../../../common/components/customized/customcalendar/CustomCalendar';
import { convertToEpoch2 } from '../../../../../utils/commonFunctions';
import CustomRadioButton from '../../../../../common/components/customized/customradiobutton/CustomRadioButton';
import './AddTrailer.scss';
import Resizer from 'react-image-file-resizer';
import dayjs from 'dayjs';
import CustomFileUpload from '../../../../../common/components/customized/fileupload/CustomFileUpload';

const trailerSchema: any = yup.object().shape({
  unitNumber: yup
    .string()
    .trim()
    .matches(/^[A-Za-z0-9\s]+$/, 'Unit Number must contains only alphabets or numbers')
    .typeError('Unit Number must be a string')
    .required('Enter the Unit Number'),
  make: yup
    .string()
    .trim()
    .matches(/^[A-Za-z\s]+$/, 'Make must contains only alphabets')
    .typeError('Make must be a string')
    .required('Enter the Make'),
  model: yup
    .string()
    .trim()
    .matches(/^[A-Za-z0-9\s]+$/, 'Model must contains only alphabets or numbers')
    .typeError('Model must be a string')
    .required('Enter the Model'),
  manufacturedYear: yup
    .number()
    .min(1, 'Manufactured Year must be at least 1')
    .typeError('Manufactured Year must be a number')
    .required('Enter the Model year'),
  ownerShip: yup.string().required('Select the Onwership'),
  owner: yup.string().when('ownerShip', {
    is: 'Hired',
    then: () => yup.string().trim().required('Enter the Owner Name'),
    otherwise: () => yup.string().trim().notRequired()
  }),
  vinNo: yup
    .string()
    .trim()
    .matches(/^[A-Za-z0-9\s]+$/, 'VIN Number must contains only alphabets or numbers')
    .typeError('VIN Number must be a string')
    .required('Enter the VIN Number'),
  trailerType: yup
    .string()
    .typeError('Trailer Type must be a string')
    .required('Select Trailer Type'),
  trailerGroup: yup
    .string()
    .typeError('Trailer Group must be a string')
    .required('Select Trailer Group'),
  unladenWeight: yup
    .number()
    .min(100, 'Unladen Weight must be at least 3 digits')
    .typeError('Unladen Weight must be a number')
    .required('Enter the Weight'),
  unladenWeightUnit: yup
    .string()
    .trim()
    .typeError('Unladen Weight Unit must be a string')
    .required('Select Weight Unit'),
  yearOfPurchased: yup
    .number()
    .min(1000, 'Year of Purchased must be at least 4 digits')
    .typeError('Year of Purchased must be a number')
    .required('Enter the Year'),
  serialNo: yup
    .string()
    .trim()
    .matches(/^[A-Za-z0-9\s]+$/, 'Serial Number must contains only alphabets or numbers')
    .typeError('Serial Number must be a string')
    .required('Enter the Serial Number'),
  axleNo: yup
    .number()
    .min(1, 'Axle Number must be at least 1')
    .typeError('Axle Number must be a number')
    .required('Enter the Number of Axles'),
  dimensionUnit: yup
    .string()
    .trim()
    .typeError('Dimension Unit must be a string')
    .required('Select Dimension Unit'),
  length: yup
    .number()
    .min(1, 'Length must be at least 1')
    .typeError('Length must be a number')
    .required('Enter the Length'),
  width: yup
    .number()
    .min(1, 'Width must be at least 1')
    .typeError('Width must be a number')
    .required('Enter the Width')
});

const trailerSchemaTwo: any = yup.object().shape({
  licensePlateNo: yup
    .string()
    .trim()
    .matches(/^[A-Za-z0-9\s]+$/, 'License must contains only alphabets or numbers')
    .typeError('License Plate Number must be a string')
    .required('Enter the License Plate Number'),
  licenseExpiryDate: yup
    .string()
    .typeError('License Expiry Date be a string')
    .required('Select License Expiry Date'),
  dotInspectionDate: yup
    .string()
    .typeError('DOT Inspection Date must be a string')
    .required('Select DOT Inspection Date'),
  insuranceName: yup
    .string()
    .trim()
    .matches(/^[A-Za-z\s]+$/, 'Insurance Name must contains only alphabets')
    .typeError('Insurance Name must be a string')
    .required('Enter the Insurance Name'),
  policyNumber: yup
    .string()
    .trim()
    .matches(/^[A-Za-z0-9\s]+$/, 'Policy Number must contains only alphabets or numbers')
    .typeError('Policy Number must be a string')
    .required('Enter the Policy Number'),
  insuranceExpiryDate: yup
    .string()
    .typeError('Insurance Expiry Date must be a string')
    .required('Select Insurance Expiry Date'),
  registeredState: yup
    .string()
    .trim()
    .matches(/^[A-Za-z\s]+$/, 'Registered State contains only alphabets')
    .typeError('Registered State must be a string')
    .required('Enter the Registered State'),
  description: yup
    .string()
    .trim()
    .typeError('Description must be a string')
    .notRequired(),
  licenseDocument: yup.string().notRequired(),
  insuranceDocument: yup.string().notRequired(),
  divider: yup.string()
});

interface AddTrailer {
  open: boolean;
  setOpen: any;
  roleType: string;
  filteredRow: any;
  label: any;
  setLabel?: any;
  setTextValue: any;
  setPageNo?: any;
  setPageSize?: any;
}

interface TextField {
  id: string;
  label: string;
  field:
    | 'unitNumber'
    | 'make'
    | 'model'
    | 'manufacturedYear'
    | 'ownerShip'
    | 'vinNo'
    | 'trailerType'
    | 'trailerGroup'
    | 'unladenWeight'
    | 'unladenWeightUnit'
    | 'yearOfPurchased'
    | 'serialNo'
    | 'axleNo'
    | 'dimensionUnit'
    | 'length'
    | 'width';
  placeholder: string;
  inputProps: {
    maxLength?: number;
    style?: React.CSSProperties;
  };
  options?: { id: string; label: string }[];
}

interface TextFieldTwo {
  id: string;
  label: string;
  field:
    | 'licensePlateNo'
    | 'licenseExpiryDate'
    | 'dotInspectionDate'
    | 'insuranceName'
    | 'policyNumber'
    | 'insuranceExpiryDate'
    | 'registeredState'
    | 'documentName'
    | 'description'
    | 'licenseDocument'
    | 'insuranceDocument'
    | 'divider';
  placeholder: string;
  inputProps: {
    maxLength?: number;
    style?: React.CSSProperties;
  };
  options?: { id: string; label: string }[];
}

const AddTrailers = ({
  open,
  setOpen,
  roleType,
  filteredRow,
  label,
  setTextValue,
  setPageNo,
  setPageSize
}: AddTrailer) => {
  const [isNextForm, setIsNextForm] = useState<boolean>(false);
  const [trailerDetails, setTrailerDetails] = useState<any>(null);
  const [trailerDetailsTwo, setTrailerDetailsTwo] = useState<any>(null);
  const [combinedTrailerDetails, setCombinedTrailerDetails] = useState<any | null>(null);
  const [isHired, setIsHired] = useState(false);
  const [licenseFiles, setLicenseFiles] = useState<File[]>([]);
  const [insuranceFiles, setInsuranceFiles] = useState<File[]>([]);
  const [files, setFiles] = useState({
    license: [],
    insurance: [],
    isSuccess: false
  });
  const [updateFiles, setUpdateFiles] = useState<any>({
    license: [],
    insurance: []
  });
  const [uploadedFilesCount, setUploadedFilesCount] = useState(0);
  const dispatch = useAppDispatch();
  const { isLoading: addLoading } = useAppSelector(state => state.addTrailer);
  const { isLoading: updateLoading, data: dataUpdate } = useAppSelector(
    state => state.updateTrailer
  );
  const { data: dataAdd } = useAppSelector(state => state.addTrailer);
  const totalFilesCount = licenseFiles.length + insuranceFiles.length;

  const {
    control: formControl1,
    handleSubmit,
    setValue,
    getValues,
    reset,
    clearErrors,
    trigger
  } = useForm({
    resolver: yupResolver(trailerSchema)
  });

  const {
    control,
    handleSubmit: handleSubmitTwo,
    setValue: setValueTwo,
    getValues: getValuesTwo,
    reset: resetTwo,
    clearErrors: clearErrorsTwo
  } = useForm<any>({
    resolver: yupResolver(trailerSchemaTwo)
  });

  const textField: TextField[] = [
    {
      id: '1',
      label: 'Unit Number',
      field: 'unitNumber',
      placeholder: 'Unit Number',
      inputProps: { maxLength: 40 }
    },
    {
      id: '2',
      label: 'VIN Number',
      field: 'vinNo',
      placeholder: 'VIN Number',
      inputProps: { maxLength: 40 }
    },
    {
      id: '3',
      label: 'Make',
      field: 'make',
      placeholder: 'Make',
      inputProps: { maxLength: 40 }
    },
    {
      id: '4',
      label: 'Model',
      field: 'model',
      placeholder: 'Model',
      inputProps: { maxLength: 40 }
    },
    {
      id: '5',
      label: 'Manufactured Year',
      field: 'manufacturedYear',
      placeholder: 'Manufactured Year',
      inputProps: { maxLength: 10 }
    },
    {
      id: '6',
      label: 'Year of Purchased',
      field: 'yearOfPurchased',
      placeholder: 'Year of Purchased',
      inputProps: { maxLength: 10 }
    },
    {
      id: '7',
      label: 'Trailer Type',
      field: 'trailerType',
      placeholder: 'Trailer Type',
      inputProps: { maxLength: 40 },
      options: [
        { id: '1410', label: '1410' },
        { id: '1600', label: '1600' },
        { id: "48' Van (48VN)", label: "48' Van (48VN)" },
        { id: "53' Flatbed (53FL)", label: "53' Flatbed (53FL)" },
        { id: "53' Stepdeck (53SD)", label: "53' Stepdeck (53SD)" },
        { id: "53' Van (53VN)", label: "53' Van (53VN)" },
        { id: '53V', label: '53V' },
        { id: '660', label: '660' },
        { id: 'ACID', label: 'ACID' },
        { id: 'AFVN', label: 'AFVN' },
        { id: "53' Reefer (53R)", label: "53' Reefer (53R)" },
        { id: 'Bitumen/Asphalt Tanker Trailer', label: 'Bitumen/Asphalt Tanker Trailer' },
        { id: 'Fuel Tanker Trailer', label: 'Fuel Tanker Trailer' },
        { id: 'Chemical Tanker Trailer', label: 'Chemical Tanker Trailer' },
        {
          id: 'Food-Grade Tanker Trailer',
          label: 'Food-Grade Tanker Trailer'
        },
        { id: 'Dry Bulk Tanker Trailer', label: 'Dry Bulk Tanker Trailer' },
        {
          id: 'LPG (Liquefied Petroleum Gas) Tanker Trailer',
          label: 'LPG (Liquefied Petroleum Gas) Tanker Trailer'
        },
        { id: 'Cryogenic Tanker Trailer', label: 'Cryogenic Tanker Trailer' }
      ]
    },
    {
      id: '8',
      label: 'Trailer Group',
      field: 'trailerGroup',
      placeholder: 'Trailer Group',
      inputProps: { maxLength: 40 },
      options: [
        { id: 'VAN', label: 'VAN' },
        { id: 'FLAT', label: 'FLAT' },
        { id: 'DUBL', label: 'DUBL' },
        { id: 'STEP', label: 'STEP' },
        { id: 'CONT', label: 'CONT' },
        { id: 'REFR', label: 'REFR' },
        { id: 'EXPD', label: 'EXPD' },
        { id: 'DUMP', label: 'DUMP' }
      ]
    },
    {
      id: '10',
      label: 'Weight Unit',
      field: 'unladenWeightUnit',
      placeholder: 'Unladen Weight Unit',
      inputProps: { maxLength: 10 },
      options: [
        { id: 'kg', label: 'kg' },
        { id: 'ton', label: 'ton' }
      ]
    },
    {
      id: '11',
      label: 'Unladen Weight',
      field: 'unladenWeight',
      placeholder: 'Unladen Weight',
      inputProps: { maxLength: 10 }
    },
    {
      id: '9',
      label: 'Owner',
      field: 'ownerShip',
      placeholder: 'Owner',
      inputProps: { maxLength: 10 }
    },
    {
      id: '12',
      label: 'Serial Number',
      field: 'serialNo',
      placeholder: 'Serial Number',
      inputProps: { maxLength: 40 }
    },
    {
      id: '13',
      label: 'Number of Axle',
      field: 'axleNo',
      placeholder: 'Axle Number',
      inputProps: { maxLength: 10 }
    },
    {
      id: '14',
      label: 'Dimension Unit ',
      field: 'dimensionUnit',
      placeholder: 'Dimension Unit',
      inputProps: { maxLength: 10 },
      options: [
        { id: 'm', label: 'm' },
        { id: 'ft', label: 'ft' }
      ]
    },
    {
      id: '15',
      label: 'Length',
      field: 'length',
      placeholder: 'Length',
      inputProps: { maxLength: 10 }
    },
    {
      id: '16',
      label: 'Width',
      field: 'width',
      placeholder: 'Width',
      inputProps: { maxLength: 10 }
    }
  ];

  const textFieldTwo: TextFieldTwo[] = [
    {
      id: '1',
      label: 'License Plate Number',
      field: 'licensePlateNo',
      placeholder: 'License Plate Number',
      inputProps: { maxLength: 40 }
    },

    {
      id: '2',
      label: 'License Expiry Date',
      field: 'licenseExpiryDate',
      placeholder: 'License Expiry Date',
      inputProps: { maxLength: 10 }
    },
    {
      id: '3',
      label: 'DOT Inspection Date',
      field: 'dotInspectionDate',
      placeholder: 'DOT Inspection Date',
      inputProps: { maxLength: 10 }
    },
    {
      id: '4',
      label: 'Registered State',
      field: 'registeredState',
      placeholder: 'Registered State',
      inputProps: { maxLength: 40 }
    },
    {
      id: '5',
      label: 'License Document',
      field: 'licenseDocument',
      placeholder: 'License Document',
      inputProps: { maxLength: 10 }
    },
    {
      id: '6',
      label: 'Divider',
      field: 'divider',
      placeholder: 'Divider',
      inputProps: { maxLength: 10 }
    },
    {
      id: '7',
      label: 'Insurance Policy Number',
      field: 'policyNumber',
      placeholder: 'Policy Number',
      inputProps: { maxLength: 40 }
    },
    {
      id: '8',
      label: 'Insurance Expiry Date',
      field: 'insuranceExpiryDate',
      placeholder: 'Insurance Expiry Date',
      inputProps: { maxLength: 10 }
    },
    {
      id: '9',
      label: 'Insurance Name',
      field: 'insuranceName',
      placeholder: 'Insurance Name',
      inputProps: { maxLength: 40 }
    },
    {
      id: '10',
      label: 'Insurance Document',
      field: 'insuranceDocument',
      placeholder: 'Insurance Document',
      inputProps: { maxLength: 10 }
    },
    {
      id: '11',
      label: 'Description',
      field: 'description',
      placeholder: 'Description',
      inputProps: { maxLength: 100 }
    }
  ];

  // function to handle upload files
  const handleUpload = async (type: 'license' | 'insurance') => {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = 'image/*';
    inputElement.multiple = true;
    inputElement.onchange = async (event: Event) => {
      const files = (event.target as HTMLInputElement).files;
      if (!files) return;
      const fileArray = Array.from(files);

      for (const file of fileArray) {
        let newFile: File;
        const fileName = file.name;
        const fileExtension = fileName.slice(fileName.lastIndexOf('.'));
        const baseName = fileName.slice(0, fileName.lastIndexOf('.'));

        if (type === 'license') {
          if (licenseFiles.some(f => f.name === fileName)) {
            newFile = new File([file], `${baseName}(1)${fileExtension}`, {
              type: file.type,
              lastModified: file.lastModified
            });
          } else {
            newFile = file;
          }
        } else if (type === 'insurance') {
          if (insuranceFiles.some(f => f.name === fileName)) {
            newFile = new File([file], `${baseName}(1)${fileExtension}`, {
              type: file.type,
              lastModified: file.lastModified
            });
          } else {
            newFile = file;
          }
        } else {
          newFile = file;
        }

        setUpdateFiles((prev: any) => {
          return {
            ...prev,
            [`${type}`]: [
              ...prev[type],
              {
                fileName: newFile.name,
                isAdded: filteredRow ? true : false,
                isDeleted: false
              }
            ]
          };
        });

        Resizer.imageFileResizer(
          newFile,
          1920,
          1920,
          'JPEG',
          50,
          0,
          (uri: any) => {
            const blob = new Blob([uri], { type: 'image/jpeg' });
            const resizedFile = new File([blob], newFile.name, { type: 'image/jpeg' });
            if (type === 'license') {
              setLicenseFiles(prev => [...prev, resizedFile]);
            } else {
              setInsuranceFiles(prev => [...prev, resizedFile]);
            }
          },
          'blob'
        );
      }
      clearErrors();
    };
    inputElement.click();
  };

  // function to handle delete files
  const handleDelete = (data: any, type: any) => {
    if (type === 'license') {
      const newFiles = licenseFiles?.filter((value: any) => value.name !== data.name);
      setLicenseFiles(newFiles);
    } else {
      const newFiles = insuranceFiles?.filter((value: any) => value?.name !== data.name);
      setInsuranceFiles(newFiles);
    }
    setUpdateFiles((prev: any) => {
      return {
        ...prev,
        [`${type}`]: prev[type].map((item: any) =>
          item.fileName === data.name ? { ...item, isDeleted: true } : item
        )
      };
    });
  };

  // function to handle radiobutton
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setIsHired(value === 'Hired');
    setValue('ownerShip', value);
    if (value === 'Owned') {
      if (!isHired) {
        setValue('owner', 'NA');
      }
    } else if (!value) {
      trigger('owner');
    }
  };

  //function for file upload in aws
  const fileUploadAWS = async (files: any) => {
    await dispatch(fileUploadTrailer(files));
  };

  // onsubmit first form
  const onSubmit = async (data: any) => {
    setTrailerDetails(data);
    setIsNextForm(true);
    const combinedData = {
      ...data
    };
    setCombinedTrailerDetails(combinedData);
  };

  // onsubmit second forma
  const onSubmitTwo = async (data: any) => {
    setTrailerDetailsTwo(data);
    const combinedData = {
      ...trailerDetails,
      ...data
    };
    setCombinedTrailerDetails(combinedData);
    payload(combinedData);
  };

  // payload data
  const payload = async (params: any) => {
    let updatePayload: any = {
      description: params.description,
      dimensionUnit: params.dimensionUnit,
      dotInspectionDate: Number(params.dotInspectionDate),
      isInsuranceChanged: 0,
      isLicenseChanged: 0,
      insuranceModel: {
        documentUploadInfoList: updateFiles.insurance,
        expireDate: Number(params.insuranceExpiryDate),
        registerNumber: params.policyNumber
      },
      insuranceName: params.insuranceName,
      length: params.length,
      licenseModel: {
        documentUploadInfoList: updateFiles.license,
        expireDate: Number(params.licenseExpiryDate),
        registerNumber: params.licensePlateNo
      },
      make: params.make,
      model: params.model,
      modelYear: params.manufacturedYear,
      ownedOrHired: isHired ? 'Hired' : 'Owned',
      ownerName: !isHired ? 'NA' : params.owner,
      registeredState: params.registeredState,
      serialNumber: params.serialNo,
      trailerAxleNumber: params.axleNo,
      trailerGroup: params.trailerGroup,
      trailerName: params.trailerName,
      trailerType: params.trailerType,
      trailerUnladenWeight: params.unladenWeight,
      trailerUnladenWeightUnit: params.unladenWeightUnit,
      unitNumber: params.unitNumber,
      vinNumber: params.vinNo,
      width: params.width,
      yearPurchased: params.yearOfPurchased,
      titleNumber: '1234'
    };

    if (filteredRow) {
      if (updateFiles.insurance.some((file: any) => file.isAdded || file.isDeleted)) {
        updatePayload.isInsuranceChanged = 1;
      }

      if (updateFiles.license.some((file: any) => file.isAdded || file.isDeleted)) {
        updatePayload.isLicenseChanged = 1;
      }

      let pay: { updatePayload: any; id: any } = {
        updatePayload: updatePayload,
        id: filteredRow.id
      };
      const response1 = await dispatch(updateTrailer(pay));
      if (
        response1?.payload?.data?.every((item: any) => Object.keys(item)?.length === 0)
      ) {
        setIsNextForm(false);
        setOpen(false);
      }
      setPageNo(1);
      setPageSize(5);
    } else {
      const response2 = await dispatch(addTrailer(updatePayload));
      if (
        response2?.payload?.data?.every((item: any) => Object.keys(item)?.length === 0)
      ) {
        setIsNextForm(false);
        setOpen(false);
      }
      setPageNo(1);
      setPageSize(5);
    }
  };

  const handleClose = () => {
    reset();
    resetTwo();
    setOpen(false);
  };

  useEffect(() => {
    setValueTwo('description', filteredRow?.description);
    setValue('dimensionUnit', filteredRow?.dimensionUnit);
    setValueTwo('dotInspectionDate', filteredRow?.dotInspectionDateFormat);
    setValueTwo(
      'insuranceDocument',
      filteredRow?.insuranceDocumentNames?.join(',') || ''
    );
    setValueTwo('insuranceExpiryDate', filteredRow?.insuranceExpireDate);
    setValueTwo('policyNumber', filteredRow?.insuranceRegisterNumber);
    setValueTwo('insuranceName', filteredRow?.insuranceName);
    setValue('length', filteredRow?.length);
    setValueTwo('licenseDocument', filteredRow?.licenseDocumentNames?.join(',') || '');
    setValueTwo('licenseExpiryDate', filteredRow?.licenseExpireDate);
    setValueTwo('licensePlateNo', filteredRow?.licenseRegisterNumber);
    setValue('make', filteredRow?.make);
    setValue('model', filteredRow?.model);
    setValue('manufacturedYear', filteredRow?.modelYear);
    setValue('ownerShip', filteredRow?.ownedOrHired);
    setValue('owner', filteredRow?.ownerName);
    setValue('serialNo', filteredRow?.serial_number);
    setValue('axleNo', filteredRow?.trailerAxleNumber);
    setValue('trailerGroup', filteredRow?.trailerGroup);
    setValue('trailerType', filteredRow?.trailerType);
    setValue('unladenWeight', filteredRow?.trailerUnladenWeight);
    setValue('unladenWeightUnit', filteredRow?.trailerUnladenWeightUnit);
    setValue('unitNumber', filteredRow?.unitNumber);
    setValue('vinNo', filteredRow?.vinNumber);
    setValue('width', filteredRow?.width);
    setValue('yearOfPurchased', filteredRow?.yearPurchased);
    setValueTwo('registeredState', filteredRow?.registeredState);
    setIsHired(filteredRow?.ownedOrHired === 'Hired');
    if (filteredRow?.licenseDocumentNames) {
      // setLicenseFiles(
      //   filteredRow.licenseDocumentNames.map(
      //     (fileName: any) => new File([], fileName.fileName)
      //   )
      // );
      setUpdateFiles((prev: any) => {
        return {
          ...prev,
          license: filteredRow.licenseDocumentNames?.map((file: any) => ({
            fileName: file,
            isAdded: false,
            isDeleted: false
          }))
        };
      });
    }
    if (filteredRow?.insuranceDocumentNames) {
      // setInsuranceFiles(
      //   filteredRow.insuranceDocumentNames.map(
      //     (fileName: any) => new File([], fileName.fileName)
      //   )
      // );
      setUpdateFiles((prev: any) => {
        return {
          ...prev,
          insurance: filteredRow.insuranceDocumentNames?.map((file: any) => ({
            fileName: file,
            isAdded: false,
            isDeleted: false
          }))
        };
      });
    }
  }, [filteredRow]);

  useEffect(() => {
    setValue('ownerShip', 'Owned');
  }, []);

  useEffect(() => {
    const trailerData = dataUpdate?.data?.length > 0 ? dataUpdate.data : dataAdd.data;
    if (trailerData?.length > 0) {
      const combinedFiles = [...licenseFiles, ...insuranceFiles];
      const filteredFiles = trailerData?.filter(
        (item: any) => Object.keys(item).length !== 0
      );
      combinedFiles?.forEach((item, index) => {
        filteredFiles.forEach((file: any, filterIndex: number) => {
          if (Object.keys(file).includes(item.name)) {
            fileUploadAWS({
              file: item,
              url: file[item.name],
              id: filterIndex + 1,
              setFiles,
              setUploadedFilesCount,
              totalFiles: combinedFiles.length
            });
          }
        });
      });
    }
  }, [dataUpdate, dataAdd, dataAdd?.data?.length, dataUpdate?.data?.length]);

  useEffect(() => {
    if (uploadedFilesCount === totalFilesCount && totalFilesCount > 0) {
      setFiles(prev => ({ ...prev, isSuccess: true }));
    }
  }, [uploadedFilesCount]);

  useEffect(() => {
    if (files.isSuccess) {
      const payload = {
        insuranceModel: {
          documentUploadInfoList: updateFiles.insurance,
          expireDate: getValuesTwo('insuranceExpiryDate'),
          registerNumber: getValuesTwo('policyNumber')
        },
        licenseModel: {
          documentUploadInfoList: updateFiles.license,
          expireDate: getValuesTwo('licenseExpiryDate'),
          registerNumber: getValuesTwo('licensePlateNo')
        },
        unitNumber: getValues('unitNumber')
      };
      dispatch(addFileStatus(payload));
      setIsNextForm(false);
      setOpen(false);
    }
  }, [files.isSuccess]);

  return (
    <Dialog
      open={open}
      maxWidth={'md'}
      fullWidth
      className='animate__animated animate__zoomInRight'
      slotProps={{ backdrop: { invisible: true } }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px !important',
            padding: '0px 20px'
          }}
        >
          <Box className='closeIcon icon-position d-flex' onClick={handleClose}>
            <CustomIconButton category='CloseValue' />
          </Box>
          <Typography sx={{ fontWeight: 700 }}>{label}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box className='animate__animated animate__zoomIn animate__fast'>
              {!isNextForm ? (
                <Grid
                  container
                  spacing={2}
                  component={'form'}
                  onSubmit={handleSubmit(onSubmit)}
                  className='animate__animated animate__zoomIn animate__slow'
                >
                  {textField?.map((item, index) => (
                    <Grid
                      item
                      sm={
                        item.id === '9'
                          ? 6
                          : item.id === '13' ||
                            item.id === '14' ||
                            item.id === '15' ||
                            item.id === '16'
                          ? 2.2
                          : 3
                      }
                      xs={12}
                      key={item.id}
                      sx={item.options ? { mt: 1 } : {}}
                    >
                      {item.options ? (
                        <CustomSelect
                          control={formControl1}
                          name={item.field}
                          placeholder={item.placeholder}
                          id={item.id}
                          label={item.label}
                          options={item.options}
                        />
                      ) : item.field === 'ownerShip' ? (
                        <>
                          <Grid container spacing={2} alignItems='center'>
                            <Grid item xs={6}>
                              <CustomRadioButton
                                formlabel='Owner'
                                name='ownerShip'
                                radiobutton1='Owned'
                                radiobutton2='Hired'
                                value1='Owned'
                                value2='Hired'
                                value={isHired ? 'Hired' : 'Owned'}
                                control={formControl1}
                                onChangeCallback={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => handleChange(e)}
                              />
                            </Grid>
                            {isHired && (
                              <Grid item xs={12} sm={6}>
                                <CustomTextField
                                  control={formControl1}
                                  name='owner'
                                  placeholder='Owner Name'
                                  id='owner'
                                  label='Owner Name'
                                  inputProps={{ maxLength: 40 }}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </>
                      ) : (
                        <CustomTextField
                          control={formControl1}
                          name={item.field}
                          placeholder={item.placeholder}
                          id={item.id}
                          label={item.label}
                          inputProps={item.inputProps}
                        />
                      )}
                    </Grid>
                  ))}
                  <CustomButton
                    className='saveChanges'
                    type='submit'
                    category='Next'
                    sx={{ marginLeft: '760px', marginTop: '5%' }}
                  />
                </Grid>
              ) : (
                <>
                  <Box component={'form'} onSubmit={handleSubmitTwo(onSubmitTwo)}>
                    <Grid container spacing={2}>
                      {textFieldTwo.map((item, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={
                            item.id === '3' || item.id === '4'
                              ? 3
                              : item.id === '11' || item.field === 'divider'
                              ? 12
                              : 6
                          }
                          key={item.id}
                          sx={
                            item.options
                              ? { mt: 1.25 }
                              : item.id === '2' || item.id === '3' || item.id === '8'
                              ? { mt: 0.5 }
                              : item.id === '5' || item.id === '10'
                              ? { mt: 3 }
                              : {}
                          }
                        >
                          {item.options ? (
                            <CustomSelect
                              control={control}
                              name={item.field}
                              placeholder={item.placeholder}
                              id={item.id}
                              label={item.label}
                              options={item.options}
                            />
                          ) : item.id === '2' || item.id === '3' || item.id === '8' ? (
                            <CustomDateCalendar
                              id={item.id}
                              name={item.field}
                              className='calendar'
                              control={control}
                              disableFuture={false}
                              disablePast={true}
                              placeholder={item.placeholder}
                              label={item.label}
                              value={
                                filteredRow
                                  ? dayjs.unix(
                                      item.field === 'licenseExpiryDate' &&
                                        filteredRow?.licenseExpireDate !== null
                                        ? filteredRow?.licenseExpireDate
                                        : item.field === 'insuranceExpiryDate' &&
                                          filteredRow?.insuranceExpireDate !== null
                                        ? filteredRow?.insuranceExpireDate
                                        : item.field === 'dotInspectionDate' &&
                                          filteredRow?.dotInspectionDateFormat !== null
                                        ? filteredRow?.dotInspectionDateFormat
                                        : filteredRow?.dotInspectionDateFormat
                                    )
                                  : null
                              }
                              onDateChange={(date: any) => {
                                const epoc = convertToEpoch2(date?.$d);
                                setValueTwo(
                                  item.field,
                                  epoc !== null ? String(epoc) : ''
                                );
                                clearErrorsTwo(item.field);
                              }}
                            />
                          ) : item.field === 'divider' ? (
                            <Grid>
                              <Box my={2}>
                                <Divider
                                  sx={{ border: '1px dashed', color: '#B2BEB5' }}
                                />
                              </Box>
                            </Grid>
                          ) : item.field === 'licenseDocument' ||
                            item.field === 'insuranceDocument' ? (
                            <CustomFileUpload
                              handleUpload={() =>
                                handleUpload(
                                  item.field === 'licenseDocument'
                                    ? 'license'
                                    : 'insurance'
                                )
                              }
                              label={
                                item.field === 'licenseDocument'
                                  ? 'Upload License Document'
                                  : item.field === 'insuranceDocument'
                                  ? 'Upload Insurance Document'
                                  : 'Upload Fitness Document'
                              }
                              files={
                                item.field === 'licenseDocument'
                                  ? updateFiles.license
                                      ?.map((item: any) => ({
                                        ...item,
                                        name: item?.fileName
                                      }))
                                      .filter((value: any) => !value.isDeleted)
                                  : updateFiles.insurance
                                      ?.map((item: any) => ({
                                        ...item,
                                        name: item?.fileName
                                      }))
                                      ?.filter((value: any) => !value.isDeleted)
                              }
                              handleDelete={(e: any) => {
                                handleDelete(
                                  e,
                                  item.field === 'licenseDocument'
                                    ? 'license'
                                    : 'insurance'
                                );
                              }}
                            />
                          ) : (
                            <CustomTextField
                              control={control}
                              name={item.field}
                              placeholder={item.placeholder}
                              id={item.id}
                              label={item.label}
                              inputProps={item.inputProps}
                              isOptional={item?.id === '11' && true}
                              type={item?.id === '11' ? 'address' : null}
                            />
                          )}
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ marginTop: '5%' }}>
                      <CustomButton
                        className='saveChanges'
                        type='button'
                        category='Back'
                        onClick={() => setIsNextForm(false)}
                      />
                      <CustomButton
                        className='saveChanges'
                        type='submit'
                        category={roleType}
                        loading={filteredRow ? updateLoading : addLoading}
                        sx={{ marginLeft: '550px' }}
                      />
                      <CustomButton
                        className='cancel'
                        category='Cancel'
                        onClick={() => {
                          handleClose();
                          setTextValue('');
                        }}
                        sx={{ marginLeft: '20px' }}
                      />
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddTrailers;
